/* eslint-disable max-len */
/* stylelint-disable max-line-length */
import {memo} from 'react';

import styled from 'styled-components';

import {getLocalizationService} from '~/shared/services/localisationService';
import ImageWithAlt from '~/shared/components/ImageWithAlt';
import {flipOnLTR, media, rotateOnLTR} from '~/shared/theme/utils';
import scooberTag from '~/assets/images/icons/scoober_tag.svg';
import {body14Bold} from '~/shared/theme/typography';
import {flexCenter} from '~/shared/theme/FlexLayout';
import {useIsMinLargeMobile, useIsMinLargeTablet} from '~/shared/hooks/deviceInfo';

const ScooberLogoIcon = styled(ImageWithAlt).attrs({noAlt: true})``;

const ScooberWrapper = styled.div.attrs({className: 'transparent-bg-on-contrast'})`
  position: absolute;
  display: flex;
  border-radius: 100px;
  align-items: center;
  gap: 4px;
  padding: 2px;
  background: ${({theme}) => theme.colors.primaryText};
  box-shadow: ${({theme}) => theme.shadows.shadow9};
  z-index: 80;
  ${flipOnLTR`
    padding-left: 6px;
  `}
`;

const ScooberMenuWrapper = styled(ScooberWrapper)`
  bottom: 16px;
  ${flipOnLTR`
    left: 16px;
    ${media.minLargeMobile`
      bottom: 0;
      left: 0;
    `}
  `}
`;

const CenteredWrapper = styled.div`
  width: 570px;
  margin: auto auto 16px;
`;

const ScooberRestaurantCardWrapper = styled(ScooberWrapper)`
  bottom: 12px;
  ${flipOnLTR`
    left: 12px;
  `}
`;

const ScooberText = styled.div`
  ${body14Bold}
  color: ${({theme}) => theme.colors.charcoal80};
`;

const ScooberTextRestaurant = styled(ScooberText)`
  line-height: 1;
`;

const ScooberLogoWrapper = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${({theme}) => theme.colors.contentBrand};
  ${flexCenter}
  ${rotateOnLTR}
`;

const DiagonalBadge = memo(() => {
  const {t} = getLocalizationService();
  return (
    <ScooberMenuWrapper>
      <ScooberLogoWrapper>
        <ScooberLogoIcon src={scooberTag} />
      </ScooberLogoWrapper>
      <ScooberText>{t('scoober_filter_label')}</ScooberText>
    </ScooberMenuWrapper>
  );
});

const RestaurantCardBadge = memo(() => {
  const {t} = getLocalizationService();
  return (
    <ScooberRestaurantCardWrapper>
      <ScooberLogoWrapper>
        <ScooberLogoIcon src={scooberTag} />
      </ScooberLogoWrapper>
      <ScooberTextRestaurant>{t('scoober_filter_label')}</ScooberTextRestaurant>
    </ScooberRestaurantCardWrapper>
  );
});

const ScooberBadge = ({top}: {top?: boolean}) => {
  const isMinLargeMobile = useIsMinLargeMobile();
  const isMinLargeTablet = useIsMinLargeTablet();

  const centerLogo = isMinLargeMobile && !isMinLargeTablet;
  if (!top) {
    return <RestaurantCardBadge />;
  }
  if (centerLogo) {
    return (
      <CenteredWrapper>
        <DiagonalBadge />
      </CenteredWrapper>
    );
  }
  return <DiagonalBadge />;
};

export default memo(ScooberBadge);
